import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './XSifterApp';
import { Provider } from 'react-redux';
import xsifterAppStore from './store/XSifterAppStore';
// import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={xsifterAppStore}>
        <App />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
